import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, Button, FormControl, FormLabel, IconButton, InputAdornment, OutlinedInput, TextField } from '@mui/material'
import React, { ChangeEvent, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useFinanceTransferBetweenMyBalancesMutation } from 'src/redux/api/cabinet';
import { updProfileData } from 'src/redux/slices/app';
import { Alerting } from 'src/views/components_cabinet/Alerting';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';


export const FormTransferBetweenMyBalances = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [login, setLogin] = React.useState<string>('');
    const [amount, setAmount] = React.useState<string>(''); // Изменено на string
    const [FP, setFP] = React.useState<string>('');
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const dispatch = useDispatch();

    const [balanceSend, setBalanceSend] = React.useState<string>('0');
    const [balanceRecive, setBalanceRecive] = React.useState<string>('0');

    const handleChange = (event: SelectChangeEvent) => {
        setBalanceSend(event.target.value as string);
    };

    const handleChange2 = (event: SelectChangeEvent) => {
        setBalanceRecive(event.target.value as string);
    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const SubmitForm = () => {
        if (balanceSend === "0") {
            setgetAlert({ type: 2, msg: 'Выберите баланс отправитель' });
            return false
        }

        if (balanceRecive === "0") {
            setgetAlert({ type: 2, msg: 'Выберите баланс получатель' });
            return false
        }

        const amountNum = parseFloat(amount);

        if (!amount || amountNum === 0 || isNaN(amountNum)) {
            setgetAlert({ type: 2, msg: 'Укажите сумму перевода' });
            return false
        }

        if (FP.length < 8) {
            setgetAlert({ type: 2, msg: 'Укажите Финансовый пароль (от 8 символов)' });
            return false
        }

        const data = { finance_password: FP, balance_send: balanceSend, balance_receive: balanceRecive, amount: amountNum };

        getRequest(data);
    }

    const [getData, { isLoading }] = useFinanceTransferBetweenMyBalancesMutation();
    const getRequest = async (data: any) => {
        const jwt = localStorage.getItem('jwt');
        await getData({ body: data, jwt })
            .unwrap()
            .then((payload: any) => {
                dispatch(updProfileData(payload.data));
                setgetAlert({ type: 1, msg: payload.message });
                setLogin('');
                setAmount(''); // Изменено на пустую строку
                setFP('');
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const checkNumberInput = (inputText: string) => {
        // Убираем все символы кроме цифр и точки
        let cleaned = inputText.replace(/[^\d.]/g, "");

        // Убираем все точки кроме первой
        const parts = cleaned.split(".");
        if (parts.length > 2) {
            cleaned = parts[0] + "." + parts.slice(1).join("");
        }

        // Ограничиваем до 4 знаков после точки
        if (parts.length === 2 && parts[1].length > 4) {
            cleaned = parts[0] + "." + parts[1].substring(0, 4);
        }

        return cleaned;
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <FormControl fullWidth sx={{ mb: 3, "& .MuiInputBase-root": { background: "#EDEDED" }, }}>
                    <FormLabel htmlFor='blssender'>
                        Баланс отправитель
                    </FormLabel>
                    <Select
                        id="blssender"
                        value={balanceSend}
                        onChange={handleChange}
                        sx={{
                            "& .MuiOutlinedInput-notchedOutline": { background: "none" }
                        }}
                    >
                        <MenuItem value="0">Выбрать</MenuItem>
                        <MenuItem value="balance">Основной баланс</MenuItem>
                        <MenuItem value="balance_zho">Баланс ПО</MenuItem>
                        <MenuItem value="balance_null">Баланс NULL</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3, "& .MuiInputBase-root": { background: "#EDEDED" }, }}>
                    <FormLabel htmlFor='blsrecive'>
                        Баланс получатель
                    </FormLabel>
                    <Select
                        id="blsrecive"
                        value={balanceRecive}
                        onChange={handleChange2}
                        sx={{
                            "& .MuiOutlinedInput-notchedOutline": { background: "none" }
                        }}
                    >
                        <MenuItem value="0">Выбрать</MenuItem>
                        <MenuItem value="balance">Основной баланс</MenuItem>
                        <MenuItem value="balance_zho">Баланс ПО</MenuItem>
                        <MenuItem value="balance_null">Баланс NULL</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ width: '100%', mb: 3 }}>
                    <FormLabel htmlFor='amount'>
                        Сумма в USDT
                    </FormLabel>
                    <TextField
                        value={amount}
                        inputMode="numeric"
                        size='medium'
                        id="amount"
                        variant="outlined"
                        type='text'
                        onInput={(el: ChangeEvent<HTMLInputElement>) => setAmount(checkNumberInput(el.target.value))}
                        placeholder="Сумма"
                        inputProps={{
                            inputMode: 'numeric',
                            autoComplete: 'off',
                        }}
                    />
                </FormControl>

                <FormControl sx={{ width: '100%', mb: 3, position: 'relative' }}>
                    <Box display='flex' justifyContent='space-between' alignItems='end' mb={1}>
                        <FormLabel htmlFor='finpas'>
                            Финансовый пароль
                        </FormLabel>
                    </Box>

                    <OutlinedInput
                        value={FP}
                        id="finpas"
                        type={showPassword ? 'text' : 'password'}
                        onInput={(el: ChangeEvent<HTMLInputElement>) => setFP(el.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff color='error' /> : <Visibility color='error' />}
                                </IconButton>
                            </InputAdornment>
                        }
                        inputProps={{
                            autoComplete: 'off',
                        }}
                        placeholder="Финансовый пароль"
                    />
                </FormControl>

                <Button onClick={SubmitForm} color='primary' variant='contained' sx={{ width: '100%' }} disabled={isLoading}>
                    {isLoading ? "Обработка..." : !amount || parseFloat(amount) === 0 ? "Перевод" : `Перевести $${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(parseFloat(amount))}`}
                </Button>
            </Box >
            {getAlert && <Alerting get={getAlert} />}
        </>
    )
}